import { StandardEvents } from '@shopify/events';

class StnixCartLink extends HTMLElement {
  revision = 0;
  connectedCallback() {
    document.addEventListener(StandardEvents.cartLinesUpdate, this.onUpdate);
    window.addEventListener('pageshow', this.onPageShow);
  }
  disconnectedCallback() {
    document.removeEventListener(StandardEvents.cartLinesUpdate, this.onUpdate);
    window.removeEventListener('pageshow', this.onPageShow);
    this.revision++;
  }
  renderCount(count, announce = true) {
    if (!Number.isInteger(count) || count < 0) return;
    const link = this.querySelector('a');
    const label = this.querySelector('[data-cart-label]');
    const status = this.querySelector('[data-cart-status]');
    if (!link || !label) return;
    link.setAttribute('aria-label', 'Cart, ' + count + (count === 1 ? ' item' : ' items'));
    label.textContent = 'CART' + (count > 0 ? ' (' + count + ')' : '');
    if (announce && status) status.textContent = 'Cart updated: ' + count + (count === 1 ? ' item' : ' items');
  }
  onUpdate = (event) => {
    const revision = ++this.revision;
    event.promise?.then(({ cart, detail }) => {
      if (this.isConnected && revision === this.revision) {
        this.renderCount(cart?.totalQuantity ?? detail?.itemCount);
      }
    }).catch(() => {});
  };
  onPageShow = (event) => {
    if (!event.persisted) return;
    const link = this.querySelector('a');
    if (!link) return;
    const revision = ++this.revision;
    fetch(link.pathname + '.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then((response) => { if (!response.ok) throw new Error('Cart unavailable'); return response.json(); })
      .then((cart) => { if (this.isConnected && revision === this.revision) this.renderCount(cart.item_count, false); })
      .catch(() => {});
  };
}
if (!customElements.get('stnix-cart-link')) customElements.define('stnix-cart-link', StnixCartLink);
